import gql from 'graphql-tag';

export default gql`
  fragment receptionNgReasonTemplateFragment on ReceptionNgReasonTemplate {
    id
    clientId
    reason
  }
`;
